import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const AddRagBody = ({ state, setState }) => {
  const { question, answer } = state;
  return (
    <>
      <Box>
        <Box>
          <Typography className="font-14-grey mb-2">Question</Typography>
          <TextField
            name="question"
            value={question}
            onChange={(e) =>
              setState((prev) => ({
                ...prev,
                question: e.target.value,
              }))
            }
            variant="outlined"
            fullWidth
            placeholder="Enter Question"
            multiline
            rows={4}
            sx={commonStyles.inputField}
          />
        </Box>
        <Box className="mt-3">
          <Typography className="font-14-grey mb-2">Answer</Typography>
          <TextField
            name="answer"
            value={answer}
            onChange={(e) =>
              setState((prev) => ({
                ...prev,
                answer: e.target.value,
              }))
            }
            variant="outlined"
            fullWidth
            placeholder="Enter Answer"
            multiline
            rows={4}
            sx={commonStyles.inputField}
          />
        </Box>
      </Box>
    </>
  );
};

export default AddRagBody;
